/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchdogDefinitionShiplist
 */
export interface WatchdogDefinitionShiplist {
    /**
     * Specify whether a shiplist shall be created for the watchdog. Optional, if not specified no shiplist will be created.
     * @type {boolean}
     * @memberof WatchdogDefinitionShiplist
     */
    active?: boolean;
    /**
     * Specify how long ships shall be included in shiplist. Only valid for watchdogs of type line. Optional, if no value is specified the timeout is 30 minutes "00:30:00". The value is specified in [HHH:MM:SS].
     * @type {string}
     * @memberof WatchdogDefinitionShiplist
     */
    timeout?: string;
}

/**
 * Check if a given object implements the WatchdogDefinitionShiplist interface.
 */
export function instanceOfWatchdogDefinitionShiplist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogDefinitionShiplistFromJSON(json: any): WatchdogDefinitionShiplist {
    return WatchdogDefinitionShiplistFromJSONTyped(json, false);
}

export function WatchdogDefinitionShiplistFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogDefinitionShiplist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
    };
}

export function WatchdogDefinitionShiplistToJSON(value?: WatchdogDefinitionShiplist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'timeout': value.timeout,
    };
}

